import React from 'react';

import Context from '../../../../../../context';

import {CustomBadges, CustomIcon, TableNullData} from '../../../../../../components';

import './index.sass';
import {locationNamespace} from "../../../../../../types/location.namespace";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import values from "../../../../../../values";

type Props = {
  data: any;
};

const Body: React.FC<Props> = ({ data }: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));
  const { setSelectedArea, setShowModal } = React.useContext(Context.Location.Area);
  const docs = data?.data?.result?.docs;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickUpdate(area: locationNamespace.area.index): void {
    setSelectedArea!(area);
    setShowModal!('UPDATE');
  }

  function onClickDelete(area: locationNamespace.area.index): void {
    setSelectedArea!(area);
    setShowModal!('DELETE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <tbody id="location-area-body-wrapper">
      {docs?.map((area: locationNamespace.area.index, index: number) => (
        <tr key={`location-area-tr-${index}`}>
          <td className="table-text">{area.name}</td>
          <td className="table-text"><CustomBadges title={area.province?.name} /></td>
          <td className="table-text"><CustomBadges title={area.city?.name}     /></td>
          <td className="table-options-wrapper">
            <CustomIcon icon={'fas fa-pencil'} type='primary' hoverTitle={'ویرایش'} onClick={() => onClickUpdate(area)} />
            {userType === 'ADMIN' && (
              <CustomIcon icon={'fas fa-trash-can-xmark'} type='danger' hoverTitle={'حذف'} onClick={() => onClickDelete(area)} />
            )}
          </td>
        </tr>
      ))}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
